module.exports = __webpack_public_path__ + "static/media/typicons.107d077d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/typicons.svg
// module id = 406
// module chunks = 0